/* eslint-disable react/prop-types */
/* eslint-disable simple-import-sort/imports */
import React, { useEffect, useRef } from 'react';
import { motion, useInView, useMotionValue, useSpring } from 'framer-motion';

import { v2 } from '../v2';

export const Reveal = ({ children, delay = 0, y = 32, ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-60px' }}
    transition={{ duration: 0.8, delay, ease: v2.ease }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Stagger = ({ children, delay = 0, gap = 0.09, ...rest }) => (
  <motion.div
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: '-60px' }}
    transition={{ staggerChildren: gap, delayChildren: delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, y = 32, ...rest }) => (
  <motion.div
    variants={{
      hidden: { opacity: 0, y },
      visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.8, ease: v2.ease },
      },
    }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const CountUp = ({ to, prefix = '', suffix = '', decimals = 0 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-40px' });
  const motionValue = useMotionValue(0);
  const spring = useSpring(motionValue, { duration: 1800, bounce: 0 });

  useEffect(() => {
    if (inView) motionValue.set(to);
  }, [inView, motionValue, to]);

  useEffect(() => {
    const unsubscribe = spring.on('change', (latest) => {
      if (ref.current) {
        ref.current.textContent = `${prefix}${latest.toFixed(
          decimals
        )}${suffix}`;
      }
    });
    return unsubscribe;
  }, [spring, prefix, suffix, decimals]);

  const initialText = `${prefix}0${suffix}`;
  // data-prerender-text lets scripts/prerender.js reset the animated value so
  // the prerendered HTML matches React's initial render during hydration.
  return (
    <span ref={ref} data-prerender-text={initialText}>
      {initialText}
    </span>
  );
};
